import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminPartnersApi as r } from "@maat/api-main";
//#region src/partners/admin/useReviewFraudFlagMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, resolution: t }) => r.reviewFraudFlag(e, t),
		onSuccess: (t, { partnerId: n }) => {
			i.invalidateQueries({ queryKey: e.fraudFlags() }), n && i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useReviewFraudFlagMutation };
